export default [
     {
          path: '/national-risk-identification',
          name: 'NationalRiskIdentification',
          component: () => import("@/views/Page/NationalRiskIdentification/NationalRiskIdentification.vue"),
          meta: {
               title: 'National Risk Identification',
          },
     },
     {
          path: '/national-risk-identification/:id',
          name: 'NationalRiskIdentificationDetails',
          component: () => import("@/views/Page/NationalRiskIdentification/components/IdentificationDetails.vue"),
          meta: {
               title: 'National Risk Identification Details',
          },
     }
];